var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"grey lighten-3",attrs:{"app":"","height":"auto"}},[_c('v-spacer'),_c('span',{staticClass:"mr-2",domProps:{"innerHTML":_vm._s(_vm.$consts.COPYRIGHT)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }